import { render, staticRenderFns } from "./QSTable.vue?vue&type=template&id=4b6955b6&scoped=true"
import script from "./QSTable.vue?vue&type=script&lang=js"
export * from "./QSTable.vue?vue&type=script&lang=js"
import style0 from "./QSTable.vue?vue&type=style&index=0&id=4b6955b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6955b6",
  null
  
)

export default component.exports